module.exports = __webpack_public_path__ + "img/reward.6d8eafe3.svg";